import React, { useState } from "react";

import { useSelector } from "react-redux";

import axios from "axios";

import {
  Check,
  Printer,
  Monitor,
  ChevronRight,
  X,
  Globe,
  Loader2
} from "lucide-react";

import { url } from "../axios/api";

import PdfViewerModal from "./PDFViewer";

import "animate.css";

const FaturaSucessoModal = ({
  faturaId,
  onClose
}) => {

  const language = useSelector(
    (state) =>
      state.language?.currentLanguage || "pt-AO"
  );

  const [showTicket, setShowTicket] =
    useState(false);

  const [showPdf, setShowPdf] =
    useState(false);

  const [ticketUrl, setTicketUrl] =
    useState("");

  const [loadingTicket, setLoadingTicket] =
    useState(false);

  // ======================================================
  // TEXTOS
  // ======================================================

  const texts = {

    "pt-AO": {
      title: "FACTURIZE",
      success: "Documento Gerado com Sucesso",
      printTicket: "Visualizar Ticket",
      generateA4: "Visualizar Documento A4",
      sendEmail: "Enviar Por Email",
      finish: "Concluir",
      generating: "Gerando ticket..."
    },

    "en-US": {
      title: "FACTURIZE",
      success: "Document Successfully Generated",
      printTicket: "View Ticket",
      generateA4: "View A4 Document",
      sendEmail: "Send By Email",
      finish: "Finish",
      generating: "Generating ticket..."
    },

    "fr-FR": {
      title: "FACTURIZE",
      success: "Document Généré avec Succès",
      printTicket: "Voir Ticket",
      generateA4: "Voir Document A4",
      sendEmail: "Envoyer Par Email",
      finish: "Terminer",
      generating: "Génération du ticket..."
    },

    "ar-SA": {
      title: "FACTURIZE",
      success: "تم إنشاء المستند بنجاح",
      printTicket: "عرض التذكرة",
      generateA4: "عرض مستند A4",
      sendEmail: "إرسال عبر البريد الإلكتروني",
      finish: "إنهاء",
      generating: "جارٍ إنشاء التذكرة..."
    },

    "zh-CN": {
      title: "FACTURIZE",
      success: "文档生成成功",
      printTicket: "查看小票",
      generateA4: "查看 A4 文档",
      sendEmail: "通过邮件发送",
      finish: "完成",
      generating: "正在生成小票..."
    }

  };

  const t =
    texts[language] || texts["pt-AO"];

  const isRTL = language === "ar-SA";

  // ======================================================
  // GERAR + ABRIR TICKET
  // ======================================================

  const handleOpenTicket =
    async () => {

      try {

        setLoadingTicket(true);

        const response = await axios.post(
            `${url}/index.php/api/prints/fatura-ticket/${faturaId}`
        );
        setTicketUrl(`${url}/index.php/api/prints/fatura-ticket-preview/${faturaId}/`);
        setShowTicket(true);

        setLoadingTicket(false);

        

      } catch (error) {

        console.error(
          "Erro ao gerar ticket:",
          error
        );

        alert(
          "Erro ao gerar ticket."
        );

      } finally {

        setLoadingTicket(false);

      }

    };

  // ======================================================
  // RENDER
  // ======================================================

  return (

    <div className="win-modal-overlay">

      <div
        className="win-modal-container"
        dir={isRTL ? "rtl" : "ltr"}
      >

        {/* HEADER */}

        <div className="win-modal-header">

          <div className="d-flex align-items-center gap-2 ms-1">

            <Globe
              size={14}
              className="text-primary"
            />

            <span className="win-modal-title">
              {t.title}
            </span>

          </div>

          <button
            className="win-close-btn"
            onClick={onClose}
          >
            <X size={16} />
          </button>

        </div>

        {/* BODY */}

        <div className="win-modal-body p-4">

          {/* SUCCESS */}

          <div className="text-center mb-4">

            <div
              className="
                success-badge-win
                animate__animated
                animate__bounceIn
              "
            >
              <Check
                size={40}
                strokeWidth={3}
              />
            </div>

            <h4
              className="
                fw-light
                mt-3
                mb-0
                animate__animated
                animate__fadeInUp
              "
            >
              {t.success}
            </h4>

          </div>

          {/* ACTIONS */}

          <div
            className="mx-auto"
            style={{
              maxWidth: "480px"
            }}
          >

            <div className="d-flex flex-column gap-2">

              {/* A4 */}

              <button
                className="
                  win-option-btn
                  animate__animated
                  animate__fadeInUp
                "
                style={{
                  animationDelay: "0.1s"
                }}
                onClick={() => setShowPdf(true)}
              >

                <div
                  className="
                    win-icon-square
                    bg-primary
                    text-white
                    border-0
                  "
                >
                  <Monitor size={16} />
                </div>

                <span>
                  Imprimir A4
                </span>

                <ChevronRight
                  size={14}
                  className="
                    ms-auto
                    opacity-50
                  "
                />

              </button>

              {/* TICKET */}

              <button
                className="
                  win-option-btn
                  animate__animated
                  animate__fadeInUp
                "
                style={{
                  animationDelay: "0.2s"
                }}
                onClick={handleOpenTicket}
                disabled={loadingTicket}
              >

                <div
                  className="
                    win-icon-square
                    bg-success
                    text-white
                    border-0
                  "
                >

                  {loadingTicket ? (
                    <Loader2
                      size={16}
                      className="spin"
                    />
                  ) : (
                    <Printer size={16} />
                  )}

                </div>

                <span>

                  {loadingTicket
                    ? t.generating
                    : "Imprimir Ticket"}

                </span>

                <ChevronRight
                  size={14}
                  className="
                    ms-auto
                    opacity-50
                  "
                />

              </button>

            </div>

          </div>

        </div>

        {/* FOOTER */}

        <div className="win-modal-footer">

          <button
            className="btn-win-primary px-4"
            onClick={onClose}
          >
            {t.finish}
          </button>

        </div>

      </div>

      {/* ======================================================
          VIEWER A4
      ====================================================== */}

      {showPdf && (

        <PdfViewerModal

          type="a4"

          pdfUrl={`${url}/index.php/api/prints/fatura/${faturaId}`}

          onClose={() =>
            setShowPdf(false)
          }

        />

      )}

      {/* ======================================================
          VIEWER TICKET
      ====================================================== */}

      {showTicket && ticketUrl && (

        <PdfViewerModal

          type="ticket"

          pdfUrl={ticketUrl}

          onClose={() =>
            setShowTicket(false)
          }

        />

      )}

      {/* ======================================================
          CSS
      ====================================================== */}

      <style>{`

        .win-modal-overlay {

          position: fixed;

          inset: 0;

          background: rgba(0,0,0,0.45);

          display: flex;

          align-items: center;

          justify-content: center;

          z-index: 9999;

          backdrop-filter: blur(2px);

        }

        .win-modal-container {

          width: 450px;

          background: #fff;

          border: 1px solid #0078d4;

          box-shadow:
            0 15px 40px rgba(0,0,0,0.25);

          animation:
            fadeScale 0.2s ease;

        }

        .win-modal-header {

          display: flex;

          justify-content: space-between;

          align-items: center;

          padding: 6px 10px;

          border-bottom:
            1px solid #f3f2f1;

          background: #fff;

        }

        .win-modal-title {

          font-size: 11px;

          color: #333;

          font-weight: 600;

        }

        .win-close-btn {

          border: none;

          background: transparent;

          padding: 8px 12px;

          cursor: pointer;

          transition:
            background 0.15s;

        }

        .win-close-btn:hover {

          background: #e81123;

          color: white;

        }

        .success-badge-win {

          width: 65px;

          height: 65px;

          background: #107c10;

          color: white;

          border-radius: 50%;

          display: flex;

          align-items: center;

          justify-content: center;

          margin: 0 auto;

          box-shadow:
            0 8px 25px rgba(16,124,16,0.25);

        }

        .win-icon-square {

          width: 32px;

          height: 32px;

          display: flex;

          align-items: center;

          justify-content: center;

          border-radius: 6px;

        }

        .win-option-btn {

          width: 100%;

          display: flex;

          align-items: center;

          gap: 15px;

          border:
            1px solid #d2d0ce;

          background: #f3f2f1;

          padding: 10px;

          color: #323130;

          font-weight: 600;

          font-size: 14px;

          transition: all 0.2s;

          border-radius: 6px;

        }

        .win-option-btn:hover {

          background: #eaeaea;

          border-color: #0078d4;

          transform:
            translateX(2px);

        }

        .win-modal-footer {

          background: #f3f2f1;

          padding: 12px;

          text-align: right;

          border-top:
            1px solid #e1dfdd;

        }

        .btn-win-primary {

          background: #0078d4;

          color: white;

          border: none;

          padding: 8px 25px;

          font-weight: 600;

          transition:
            background 0.15s;

          border-radius: 4px;

        }

        .btn-win-primary:hover {

          background: #005a9e;

        }

        .spin {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {

          from {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }

        }

        @keyframes fadeScale {

          from {
            transform: scale(1.03);
            opacity: 0;
          }

          to {
            transform: scale(1);
            opacity: 1;
          }

        }

      `}</style>

    </div>

  );

};

export default FaturaSucessoModal;
